// extracted by mini-css-extract-plugin
module.exports = {"main":"Whatsapp_main__1TM-O","inner":"Whatsapp_inner__1cNMJ"};